import uploadClient from '../../../clients/upload';

const prepareFiles = async (file) => {
  if (!file) {
    return null;
  }

  // If file already has an id, it's already uploaded
  if (file.id) {
    return file.id;
  }

  // If it's a File object, upload it
  if (file instanceof File) {
    const uploadedFiles = await uploadClient.upload([file]);
    if (uploadedFiles.length > 0) {
      return uploadedFiles[0].id;
    }
  }

  return null;
};

export const prepareMultipleFiles = async (files) => {
  if (!Array.isArray(files) || files.length === 0) {
    return [];
  }
  const newFiles = files.filter((f) => !f?.id);
  if (newFiles.length === 0) {
    return files.map((f) => f.id).filter(Boolean);
  }
  const uploadedFiles = await uploadClient.upload(newFiles);
  const existingIds = files.filter((f) => f?.id).map((f) => f.id);
  return [...existingIds, ...uploadedFiles.map((f) => f.id)];
};

export default prepareFiles;
